import { useMemo, Children } from "react";
function useChildrenAsLabel(children) {
  return useMemo(() => {
    let label = [];
    Children.map(children, (child) => {
      if (typeof child === "string") {
        label.push(child);
      }
    });
    return label.length > 0 ? label.join(" ") : void 0;
  }, [children]);
}
export {
  useChildrenAsLabel
};
//# sourceMappingURL=useChildrenAsLabel.js.map
